import { useHttp } from "../http/useHttp";
import { useAxiosMutation } from "../http/useAxiosMutation";
import { paths } from "../generated-types";

type ActivateUserOperation = paths["/dashboard/activate-user"]["post"];
export type IActivateUserInput =
  ActivateUserOperation["requestBody"]["content"]["application/json"];
type UseActivateUserResponse =
  ActivateUserOperation["responses"][200]["content"]["application/json"];

export const useActivateUser = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMutation<
    UseActivateUserResponse,
    IActivateUserInput
  >({
    mutationKey: ["activate-user"],
    mutationFn: (input) => client.post("/activate-user", input),
  });

  return { activateUser: mutate, isPending, status, data, error };
};
